/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {}
 */
export interface DidDocumentSelfGetRequest {
    /**
     * From [Zalando RESTful API Guidelines - models/headers-1.0.0.yaml](https://opensource.zalando.com/restful-api-guidelines/models/headers-1.0.0.yaml).
     * The **If-None-Match header** field is used to declare a list of identifiers
     * that are required to fail matching all the current resource version
     * identifiers as a pre-condition for executing the request on the server
     * side. This is especially used in conjunction with an **\*** (asterix) that
     * is matching all possible resource identifiers to ensure the initial
     * creation of a resource. Other use cases are possible but rare.
     *
     * If the pre-condition fails the server will respond with status code **412**
     * (Precondition Failed). See [RFC 9110 Section 13.1.2][rfc-9110-13.1.2] as
     * well as [API Guideline Rule #182][api-182] for further details.
     *
     * [rfc-9110-13.1.2]: <https://tools.ietf.org/html/rfc9110#section-13.1.2>
     * [api-182]: <https://opensource.zalando.com/restful-api-guidelines/#182>.
     */
    ifNoneMatch?: string;
}
